import {
  apiClient,
  type MonthlyTourReportListExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyTourReportsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyTourReportsQuery = {
  tenantKey: string
  query: MonthlyTourReportsRequestQuery
}

export type FetchMonthlyTourReportsResponse = {
  data: MonthlyTourReportListExEntity[]
  pagination: PageEntity | null
}

export const fetchMonthlyTourReports = async (
  { tenantKey, query }: FetchMonthlyTourReportsQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyTourReportsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports.$get({ query, config: { signal } })
  return { data, pagination }
}
